import { reactive } from "vue";

//footer applicativo
export const store = reactive({
  Con_rag1: "",
  Ind_loc1: "",
  Ind_ind1: "",
  Cap_cod1: "",
  Naz_cod1: "",
  Com_cod1: "",
  Ind_tel1: "",
  Ind_ema1: "",
  Inf_gatc: "",
  Rst_codi: "",
  setRst_codi(Rst_codi){
      this.Rst_codi = Rst_codi;
  },
  set(newval) {
    this.Con_rag1 = newval.Con_rag1;
    this.Ind_loc1 = newval.Ind_loc1;
    this.Ind_ind1 = newval.Ind_ind1;
    this.Cap_cod1 = newval.Cap_cod1;
    this.Naz_cod1 = newval.Naz_cod1;
    this.Com_cod1 = newval.Com_cod1;
    this.Ind_tel1 = newval.Ind_tel1;
    this.Ind_ema1 = newval.Ind_ema1;
    this.Inf_gatc = newval.Inf_gatc;
  },
});
